import { render, staticRenderFns } from "./ScreenConfig.vue?vue&type=template&id=2a0563b8&scoped=true&"
import script from "./ScreenConfig.vue?vue&type=script&lang=js&"
export * from "./ScreenConfig.vue?vue&type=script&lang=js&"
import style0 from "./ScreenConfig.vue?vue&type=style&index=0&id=2a0563b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0563b8",
  null
  
)

export default component.exports